import {
  trackProductError,
  trackProductEvent,
  type ProductBaseProperties,
} from "./product";

export const INVENTORY_FLOW = "inventory";

export type InventoryEventName =
  | "inventory_create_clicked"
  | "inventory_create_submit_attempt"
  | "inventory_item_created"
  | "inventory_create_error"
  | "inventory_update_submit_attempt"
  | "inventory_item_updated"
  | "inventory_update_error"
  | "inventory_item_deleted"
  | "inventory_delete_error"
  | "form_chat_started"
  | "form_chat_field_collected"
  | "form_chat_completed"
  | "form_chat_submitted"
  | "form_chat_inventory_created"
  | "form_chat_submit_error";

export const trackInventoryEvent = (
  event: InventoryEventName,
  baseProperties: ProductBaseProperties,
  eventProperties?: Record<string, unknown>,
): void => {
  trackProductEvent(event, baseProperties, eventProperties, INVENTORY_FLOW);
};

export const trackInventoryError = (
  event: InventoryEventName,
  baseProperties: Omit<ProductBaseProperties, "success" | "errorCode">,
  error: unknown,
  eventProperties?: Record<string, unknown>,
): void => {
  trackProductError(
    event,
    baseProperties,
    error,
    eventProperties,
    INVENTORY_FLOW,
  );
};
